import { useLayoutEffect, useRef } from "react";

/** Reset page navigation without disturbing same-page state or source anchors. */
export function usePageScrollReset(pathname: string) {
  const previousPath = useRef(pathname);

  useLayoutEffect(() => {
    if (previousPath.current === pathname) return;
    previousPath.current = pathname;

    if (window.location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
}
